import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

/**
 * Toggles whether this simulation's scheduled ticker runs automatically.
 * When disabled, every agent's manual force-tick still works — only the
 * interval-based auto-ticking is skipped. Takes effect on the very next
 * scheduled tick, including while running. Response echoes
 * `{ simulationId, autoTickEnabled }`.
 */
const setSimulationAutoTickEnabled = (
  simulationId,
  enabled,
  callback,
  errorCallback,
) => {
  return async (dispatch) => {
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.patch(
            `/ads/admin/simulations/${simulationId}/auto-tick`,
            { enabled },
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            if (typeof callback === 'function') callback(response?.data);
          } else {
            if (typeof errorCallback === 'function')
              errorCallback('Failed to update auto-tick setting');
          }
        } catch (e) {
          if (typeof errorCallback === 'function')
            errorCallback(
              e?.response?.data?.message ||
                'Failed to update auto-tick setting',
            );
        }
        unsubscribe();
      });
    } catch (e) {
      if (typeof errorCallback === 'function')
        errorCallback('Failed to update auto-tick setting');
    }
  };
};

export default setSimulationAutoTickEnabled;
